<template>
  <div class="modal-overlay">
    <div class="close" :style="{ 'border-color': primaryColor ? primaryColor : '#CCC' }">
      <div class="container-text" :class="scrollbarThumbClass">
        <div
          v-html="termHtml"
          class="html-wrapper"
          :style="template.secondaryTheme ? { color: primaryColor } : { color: 'black' }"
        ></div>
      </div>
      <div class="div-button">
        <button
          @click="$emit('close-modal')"
          class="button-terms"
          :style="{ background: btnColor, color: btnTextColor }"
        >
          {{ $t('common.understood') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/store/store.js'
import { mapState } from 'vuex'
import { loginFB } from '../services/ServFB.js'
const lFB = new loginFB()
export default {
  name: 'ModalTerms',
  components: {},
  props: {
    termHtml: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    terms: '',
  }),
  methods: {
    getTerms() {
      if (!this.domain || !this.subdomain) return
      lFB
        .getFileContentLoc(this.domain, this.subdomain)
        .then(res => {
          if (res) {
            this.terms = res
          }
        })
        .catch(err => alert(err))
    },
  },
  watch: {
    domain(newValue) {
      if (newValue) this.getTerms()
    },
    subdomain(newValue) {
      if (newValue) this.getTerms()
    },
  },
  mounted() {
    this.getTerms()
  },
  computed: {
    ...mapState(['domain', 'subdomain', 'template']),
    primaryColor() {
      return store.state.template.primaryColor
    },
    secondaryColor() {
      return store.state.template.secondaryColor
    },
    btnColor() {
      return store.state.template.primaryBtn.bgColor
    },
    btnTextColor() {
      return store.state.template.primaryBtn.textColor
    },
    scrollbarThumbClass() {
      return this.template.secondaryTheme ? 'scroll-thumb-primary' : 'scroll-thumb-black'
    },
  },
}
</script>
<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #000000aa;
  z-index: 1000;
}

.close {
  width: 340px;
  height: 480px;
  cursor: pointer;
  background-color: #fff;
  opacity: 1;
  border-radius: 7px;
  align-items: center;
  display: flex;
  flex-direction: column;
}

.close:hover {
  opacity: 1 !important;
  cursor: context-menu !important;
}

.close-modal {
  color: white;
  font-size: 1.3rem !important;
  margin-left: 10px;
  margin-top: 7px;
  text-align: right;
  margin-right: 49px;
  top: 12px;
  position: relative;
}

.close-modal:hover {
  font-size: 1.4rem !important;
  cursor: pointer;
}

.html-wrapper {
  font-weight: 400;
  width: 285px;
  margin: 8px 24px;
  text-align: center;
}

.container-text {
  height: 390px;
  margin-top: 20px;
  overflow-y: scroll;
  overflow-x: hidden;
}

::-webkit-scrollbar {
  width: 15px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 15px grey;
  border-radius: 3px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: var(--primary-color);
  border-radius: 3px;
  height: 23px;
  cursor: pointer;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #ffffff;
}

.button-terms {
  width: 210px;
  height: 43px;
  font-size: 1rem;
  margin-top: 13px;
  border-radius: 10px;
  font-weight: 600;
  border: none;
}

.button-terms:hover {
  transition: 0.3s;
  position: relative;
  opacity: 1;
}

.div-button {
  width: 400px;
  align-items: center;
  justify-content: center;
  display: flex;
}

@media screen and (min-width: 470px) {
  .close {
    width: 435px;
    height: 580px;
  }

  .close-modal {
    color: white;
    font-size: 1.3rem !important;
    margin-left: 10px;
    margin-top: 7px;
    text-align: right;
    margin-right: 49px;
    top: 12px;
    position: relative;
  }

  .close-modal:hover {
    font-size: 1.4rem !important;
    cursor: pointer;
  }

  .html-wrapper {
    font-weight: 400;
    width: 365px;
    text-align: justify;
  }

  .container-text {
    height: 490px;
    margin-top: 20px;
    overflow-y: scroll;
    overflow-x: hidden;
  }
}

@media screen and (min-width: 767px) {
  .modal-overlay {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #000000aa;
    z-index: 1000;
  }

  .close {
    width: 500px;
    height: 550px;
  }

  .close:hover {
    opacity: 1 !important;
    cursor: context-menu !important;
  }

  .close-modal {
    color: white;
    font-size: 1.3rem !important;
    margin-left: 10px;
    margin-top: 7px;
    text-align: right;
    margin-right: 49px;
    top: 12px;
    position: relative;
  }

  .close-modal:hover {
    font-size: 1.4rem !important;
    cursor: pointer;
  }

  .html-wrapper {
    color: white;
    font-weight: 400;
    width: 410px;
    text-align: justify;
  }

  .container-text {
    height: 460px;
    margin-top: 20px;
    overflow-y: scroll;
  }

  .button-terms {
    width: 210px;
    height: 43px;
    font-size: 1rem;
    margin-top: 13px;
    border-radius: 10px;
    font-weight: 600;
  }
}
</style>
